import { DateTime, ToRelativeOptions } from "luxon";
import { useEffect, useState } from "react";
import { SimpleTooltip } from "./simple-tooltip";

export default function Since({ dt, options }: { dt: string; options?: ToRelativeOptions }) {
    const [dtDisplay, setDTDisplay] = useState<string | null>("");

    useEffect(() => {
        const _dt = DateTime.fromISO(dt);
        // Initial call
        setDTDisplay(_dt.toRelative(options));
        //Implementing the setInterval method
        if (_dt > DateTime.now().minus({ minutes: 60 })) {
            const interval = setInterval(
                () => {
                    setDTDisplay(DateTime.fromISO(dt).toRelative(options));
                },
                _dt > DateTime.now().minus({ seconds: 60 }) ? 5000 : 30000
            );
            //Clearing the interval
            return () => clearInterval(interval);
        }
    }, [dtDisplay]);

    return (
        <>
            <SimpleTooltip message={DateTime.fromISO(dt).toLocaleString(DateTime.DATETIME_MED)}>{dtDisplay}</SimpleTooltip>
        </>
    );
}
